export default {
  SCOPE_CREDENTIALS_UPDATED: 'AUTH/SCOPE_CREDENTIALS_UPDATED',
  USER_LOGIN: 'AUTH/USER_LOGIN',
  USER_LOGOUT: 'AUTH/USER_LOGOUT',
};
